import React from 'react';
import useSheet from 'app/jss';
import classNames from 'classnames';
import Icon from 'app/components/commons/Icon';

type Props = {
  classes: Object,
  icon?: string,
  children: React$Element | Array<React$Element>,
  className?: string,
};

type State = {};


class FriendsBannerInfo extends React.Component {
  props: Props;
  state: State = {};

  static defaultProps = {
    icon: '',
    className: undefined,
  };

  render() {
    const {
      classes,
      icon,
      children,
      className,
    } = this.props;
    return (
      <div className={classNames(classes.banner, className)}>
        {children}
        <div className={classes.watermark}>
          <Icon type={icon} />
        </div>
      </div>
    );
  }
}

function applyStyles(theme: Theme) {
  return {
    banner: {
      display: 'flex',
      flexDirection: 'column',
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: 0,
      left: 0,
      overflow: 'hidden',
      boxShadow: 'inset 0 0 3px 0 rgba(0,0,0,0.5)',
      backgroundColor: theme.color.basis1,
    },
    watermark: {
      height: 400,
      width: 400,
      fontSize: 160,
      position: 'absolute',
      color: theme.color.basis6,
      border: `3rem solid ${theme.color.basis6}`,
      borderRadius: '100%',
      padding: '3rem',
      transform: 'translate3d(-20%, 33%, 0)',
      left: 0,
      bottom: 0,
      opacity: 0.1,
      pointerEvents: 'none',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  };
}

export default useSheet(applyStyles)(FriendsBannerInfo);
